export default __webpack_public_path__ + "static/media/e67e57f034e01c28d968ab11125a5fda1598888534343.1fbefda2.webp";